// React
import React from 'react';
// Assets
import FileIcon from '../../../assets/file.png';
// Styles
import { PreviewContainer, PreviewFileName, PreviewFileRemove, PreviewFileSize, PreviewFileType, PreviewItem } from './StyledPreview';

const Preview = ({ files, removeFileCallback }) => {
    const fileSize = (size) => {
        if (size === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(size) / Math.log(k));
        return parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    const fileType = (fileName) => {
        return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) || fileName;
    }

    return (
        <PreviewContainer>
            {files.map((data, i) =>
                <PreviewItem key={i}>
                    <img src={FileIcon} alt="file_icon" />
                    <PreviewFileType>{fileType(data.name)}</PreviewFileType>
                    <PreviewFileName>{data.name}</PreviewFileName>
                    <PreviewFileSize>{fileSize(data.size)}</PreviewFileSize>
                    <PreviewFileRemove onClick={() => removeFileCallback(data.name)}>
                        <i className="fas fa-times fa-lg"></i>
                    </PreviewFileRemove>
                </PreviewItem>
            )}
        </PreviewContainer>
    );
}

export default Preview;
